<template>
  <v-container fill-height style="min-height: calc(100vh - 70px - 84px);">
    <v-row class="d-flex justify-center">
      <v-col cols="12" md="3" class="align-self-center">
        <v-card
          color="blue darken-4"
          dark
          flat
          :to="{ name: 'Bukutamu' }">
          <v-card-title class="text-h5">
            Buku Tamu
          </v-card-title>
          <v-card-subtitle>
            Buku tamu digital PNB
          </v-card-subtitle>
          <v-card-title class="pt-0">
            <v-icon size="60">mdi-book-open</v-icon>
          </v-card-title>
        </v-card>
      </v-col>
      <v-col cols="12" md="3" class="align-self-center">
        <v-card
          color="red accent-4"
          dark
          flat
          :to="{ name: 'Feedback' }">
          <v-card-title class="text-h5">
            Feedback Layanan
          </v-card-title>
          <v-card-subtitle>
            Rating dan Tanggapan pengunjung
          </v-card-subtitle>
          <v-card-title class="pt-0">
            <v-icon size="60">mdi-chat-processing</v-icon>
          </v-card-title>
        </v-card>
      </v-col>
      <v-col cols="12" md="3" class="align-self-center">
        <v-card
          color="green darken-4"
          dark
          flat
          :to="{ name: 'Antrian' }">
          <v-card-title class="text-h5">
            Antrian
          </v-card-title>
          <v-card-subtitle>
            Ambil nomor antrian
          </v-card-subtitle>
          <v-card-title class="pt-0">
            <v-icon size="60">mdi-human-queue</v-icon>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'Index',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      contact: false,
      regnew: false,
    },
    api: process.env.VUE_APP_API,
    apptitle: process.env.VUE_APP_TITLE,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    datepick: {
      date: new Date().toISOString().substr(0, 10),
      tgllahir: false,
    },
    publickey: '123',
    contact: {
      name: '',
      email: '',
      subject: '',
      message: '',
    },
    formin: {
      password: false,
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => v.length >= 6 || 'Min 6 characters',
      nik: (v) => (v.length >= 16 || v === 'majujaya') || 'Min 16 characters',
      phone: (v) => (!!v && v.length <= 12) || 'Max 12 characters',
      email: [
        (v) => !!v || 'E-mail is required',
        (v) => (!!v && /.+@.+\..+/.test(v)) || 'E-mail must be valid',
      ],
      files: [
        (value) => !value || value.size < 1000000 || 'File kurang dari 1 MB!',
        (value) => !!value || 'Required.',
      ],
    },
    word: 'Vue',
    dmodal: {
      register: false,
    },
    regflag: false,
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
    ]),
  },
  watch: {
    'datepick.tgllahir'(val) {
      if (val) {
        setTimeout(() => (this.$refs.birthday.activePicker = 'YEAR'));
      }
    },
  },
  created: () => ({
  }),
  mounted() {
    // console.log('1');
  },
  methods: {
    submitContact() {
      this.alertdata.show = false;
      if (this.$refs.formcontact.validate()) {
        this.loading.contact = true;
        this.axios
          .post(
            this.api + '/public/contact',
            qs.stringify(
              this.contact,
            ),
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'bearer ' + this.publickey,
              },
            },
          )
          .then((res) => {
            this.alertdata.show = true;
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                if (resdata.data.data === 1) {
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'Thank you for getting in touch!';
                } else {
                  this.alertdata.type = 'error';
                  this.alertdata.text = 'Sorry we get error in your sending email, please try again!';
                }
              } else {
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.contact = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
            this.loading.contact = false;
          });
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
